module.exports = __webpack_public_path__ + "img/23.e93dde77.jpg";